import React from 'react';
import DownloadButton from '../shared/DownloadButton';
import { Dropdown, Checkbox, Button } from 'semantic-ui-react';

const CollectionFilters = (props) => {

    const { onExportClick, onVarianceHistoryClick, to, disabled, onRefreshClick, periods, from, onChange, currentWeek, onChangeCurrentWeek, showVarianceHistory, loading, loadingExport } = props;

    return (
        <>
            <DownloadButton loading={loadingExport} onClick={onExportClick} className="mr-1" />
            From: 
            <Dropdown selection options={periods} name="from" value={from} onChange={onChange} className="ml-1 mr-1" />
            { !currentWeek &&
            <>
              To:
              <Dropdown selection options={periods} name="to" value={to} onChange={onChange} disabled={currentWeek} className="ml-1" />
            </>
            }
            <Checkbox className="ml-1" label="Current Week" checked={currentWeek} onChange={onChangeCurrentWeek} />
            { showVarianceHistory && <Button disabled={loading || disabled} onClick={onVarianceHistoryClick} color="blue" floated="right">Site Variance History</Button> }
            <Button disabled={loading || disabled || periods.length < 1} className="ml-1" onClick={onRefreshClick} positive>Refresh</Button>
        </>
    )
}

export default CollectionFilters;